module.exports = __webpack_public_path__ + "img/produk@2x.84ab084f.png";